import React, { useContext, useState } from "react";
import "./ActionItems.css";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import useRequests from "../../../hooks/useRequests";
import { UserContext } from "../../../context/UserContext";

// const sampleItems = [
//   {
//     id: "REQ-001",
//     client: "Alice Brown",
//     from: "Provider A",
//     requestedBy: "User X",
//     status: "Pending",
//     fees: "$50.00",
//   },
//   {
//     id: "REQ-002",
//     client: "Bob Smith",
//     from: "Provider B",
//     requestedBy: "User Y",
//     status: "Awaiting",
//     fees: "$75.00",
//   },
//   {
//     id: "REQ-003",
//     client: "Carol Jones",
//     from: "Provider C",
//     requestedBy: "User Z",
//     status: "Pending",
//     fees: "$65.00",
//   },
// ];

export default function ActionItems() {
  const [filter, setFilter] = useState("All");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const {
    user: { id: userId },
  } = useContext(UserContext);
  const { requests } = useRequests(userId);

  const sortBy = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="sort-icon" />;
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon" />
    ) : (
      <FaSortDown className="sort-icon" />
    );
  };

  return (
    <div className="action-items-page">
      <div className="page-title-card">
        <h2>Action Items</h2>
      </div>
      <div className="alert-card">
        <p>
          The items below are awaiting your action before Nobelflow can continue
          processing them. For each item, please check the Status in the table
          and use the buttons on the right to move the request forward. Note:
          Your standard Nobelflow service fee applies on new requests.
        </p>
      </div>
      <div className="filter-bar">
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option>All</option>
          <option>Pending</option>
          <option>Awaiting</option>
          <option>Completed</option>
        </select>
      </div>
      <div className="ait-table-container">
        <table className="action-table">
          <thead>
            <tr>
              <th onClick={() => sortBy("id")}>
                Request ID {renderSortIcon("id")}
              </th>
              <th onClick={() => sortBy("client")}>
                Client Name {renderSortIcon("client")}
              </th>
              <th onClick={() => sortBy("from")}>
                Requesting From {renderSortIcon("from")}
              </th>
              <th onClick={() => sortBy("requestedBy")}>
                Requested By {renderSortIcon("requestedBy")}
              </th>
              <th onClick={() => sortBy("status")}>
                Status {renderSortIcon("status")}
              </th>
              <th onClick={() => sortBy("fees")}>
                HIC Fees (incl. tax) {renderSortIcon("fees")}
              </th>
            </tr>
          </thead>
          {requests.map((item, idx) => (
            <tr key={idx}>
              <td>{item.request_id}</td>
              <td>{item.client_name}</td>
              <td>{item.requesting_from}</td>
              <td>{item.requested_by}</td>
              <td>{item.status}</td>
              <td>${item.hic_fees.toFixed(2)}</td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
}
